import * as React from 'react'

function ImageBackground(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={162}
      height={116}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.172 35.807L55.24 14.534 22.243 32.13S30.79-2.18 63.203 9.416c-.008.008-4.988 36.043-34.031 26.391zM41.807 97.686l-29.632-15.56 29.17 23.36S7.196 111.14 4.357 76.837c0 .008 34.245-9.597 37.45 20.85zM161.51 0h-13.293c-5.617 10.807-13.469 20.79-23.139 29.204-17.394 15.127-40.27 25.182-66.145 29.077-.24.04-.48.088-.71.16-2.594.712-4.38 3.088-4.38 5.767 0 .296.015.592.063.896.495 3.28 3.543 5.536 6.806 5.048 4.237-.64 8.402-1.432 12.479-2.376 23.035-5.311 43.501-15.39 59.73-29.509C145.36 27.453 155.119 14.262 161.51 0z"
        fill="#A3A3A3"
      />
      <path
        d="M11.63 0h.441c-.384 16.965 2.173 32.483 13.17 41.888 5.166 4.413 11.822 7.061 18.864 9.862l.054.022.361.143c2.204.878 4.466 1.78 6.686 2.745a119.888 119.888 0 017.294 3.478A117.836 117.836 0 0180.496 72.89c12.209 10.36 22.936 31.26 26.07 43.109H94.242c-2.51-9.453-11.245-25.285-21.562-34.03a105.757 105.757 0 00-26.3-16.376c-2.164-.94-4.36-1.815-6.686-2.738-7.67-3.047-15.599-6.199-22.292-11.928C3.711 39.231.007 21.875.007 3.143c0-.477-.016-2.657 0-3.143H11.63z"
        fill="#A3A3A3"
      />
    </svg>
  )
}

export default ImageBackground
